<template>
    <div :class="['container', _isMobile() ? 'mobile' : '']">
      <Header2 v-if="tenantConfig.headerType == 2" id="header"/>
      <Header3 v-else-if="tenantConfig.headerType == 3" id="header"/>
      <Header v-else id="header"/>
      <div class="home">
        <div class="pageLeft">
          <mockSideMenu />
        </div>
        <div class="pageRight"><router-view /></div>
      </div>
    </div>
  </template>
  
  <script>
  import { mixinDevice } from "@/utils/mixin.js";
  import Header from "@/components/header/Header";
  import Header2 from "@/components/header/Header2";
  import Header3 from "@/components/header/Header3";
  import Banner from "../components/Banner";
  import mockSideMenu from '../components/mockSideMenu'
  import Footer from "@/components/footer/Footer";
  export default {
    name: "HomeLayout",
    mixins: [mixinDevice],
    components: {
      Header,
      Header2,
      Header3,
      Banner,
      Footer,
      mockSideMenu
    },
    data() {
      return {
        tenantConfig: {}
      };
    },
    created() {
      this.tenantConfig = this.$store.getters.tenantInfo;
    },
  };
  </script>
  <style lang="sass">
    @import '../assets/index.scss'
  </style>
  <style>
    a *{
      transition: all 0.1s ease;
    }
  </style>
  <style lang="less" scoped>
  .container {
    .banner-wrap {
     padding: 80px 0;
      background: #24A6E9;
      .banner-bg{
        position: absolute;
        width: 100%;
      }
      .banner {
        margin: auto;
        max-width: 1200px;
        overflow: hidden;
        border-radius: 28px;
        box-shadow: 0px 6px 10px #0303031f;
      }
    }
    .home {
      width: 100%;;
      // margin: 20px auto;
      // padding: 20px 10px;
      background: #ffffffd1;
      display: flex;
      align-items: self-start;
      justify-content: flex-start;
      .pageLeft{
        width: 180px;
        height: calc(100vh - 75px);
        background: #fff;
      }
      .pageRight{
        width: calc(100vw - 180px);
        height: calc(100vh - 75px);
        // height: auto;
        background: #e6f2ff;
        padding: 8px;
        overflow-y: auto;
      }
      // border-radius: 30px;
    }
    /deep/.ant-list-pagination {
      text-align: center;
    }
    // background: url(~@/assets/background.svg);
  }
  </style>